// extracted by mini-css-extract-plugin
export default {"center":"NotFound_center__1djue","info":"NotFound_info__0+j7f"};